const config = { domain: 'Fundraising', subdomain: 'SavedFunders' }

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface NavigationItemClicked {}

export const savedFunders = {
  Clicked: {
    Clicked: (param: NavigationItemClicked) => param,
    config,
  },
}
